import React, { useEffect, useState } from 'react';
import { useHunterFarmerList } from '@/api/auth/useHunterFarmerList';

const Filters = ( {fromAll, onFilterChange} ) => {

  const [selectedProduct, setSelectedProduct] = useState([]);
  const [selectedAllStatus, setSelectedAllStatus] = useState([]);
  const [selectedRemittanceStatus, setSelectedRemittanceStatus] = useState([]);
  const [selectedReferralStatus, setSelectedReferralStatus] = useState([]);
  const [selectedInsuranceStatus, setSelectedInsuranceStatus] = useState([]);
  const [selectedFarmer, setSelectedFarmer] = useState([]);
  const {farmerListAPI} = useHunterFarmerList()

    const productsOptions = [
        { id: 1, label: 'Remittance' },
        { id: 2, label: 'Insurance' },
        { id: 3, label: 'Re-KYC' },
        { id: 4, label: 'Referral' },
        { id: 5, label: 'Financing' },
        { id: 6, label: 'Insurance Renewal' },
    ];
    const allStatus = [
        { id: 1, label: 'Raw Lead' },
        { id: 2, label: 'Fresh Lead' },
        { id: 3, label: 'Profile Completed' },
        { id: 4, label: 'Activated' },
        { id: 5, label: 'Rejected' }
    ];
    const remittanceStatus = [
        { id: 1, label: 'Collecting Documents' },
        { id: 2, label: 'Compliance Reviewing' },
        { id: 3, label: 'Pending Resubmission' },
        { id: 4, label: 'KYC Approved' },
        { id: 5, label: 'To Be Re-KYC' },
        { id: 6, label: 'KYC Rejected' },
    ];
    const referralStatus = [
        { id: 1, label: 'Information Gathered' },
        { id: 2, label: 'Onboarded' }
    ];
    const insuranceStatus = [
        { id: 1, label: 'Preparing Quotation' },
        { id: 2, label: 'Pending Selection' },
        { id: 3, label: 'Pending Payment' },
        { id: 4, label: 'Expired' }
    ];

    const handleToggleProduct = (optionId) => {
        setSelectedProduct(prev => 
        prev.includes(optionId)
            ? prev.filter(id => id !== optionId)
            : [...prev, optionId]
        );
    };

    const handleToggleAllStatus = (optionId) => {
        setSelectedAllStatus(prev => 
        prev.includes(optionId)
            ? prev.filter(id => id !== optionId)
            : [...prev, optionId]
        );
    };
    const handleFarmerListToggle = (optionId) => {
      setSelectedFarmer(prev => 
        prev.includes(optionId)
          ? prev.filter(id => id !== optionId)
          : [...prev, optionId]
      );
    }
    const handleToggleRemittanceStatus = (optionId) => {
        setSelectedRemittanceStatus(prev =>
        prev.includes(optionId)
            ? prev.filter(id => id !== optionId)
            : [...prev, optionId]
        );
    };
    const handleToggleReferralStatus = (optionId) => {
      setSelectedReferralStatus(prev =>
        prev.includes(optionId)
          ? prev.filter(id => id !== optionId)
          : [...prev, optionId]
      );
    };
    const handleToggleInsuranceStatus = (optionId) => {
      setSelectedInsuranceStatus(prev =>
        prev.includes(optionId)
          ? prev.filter(id => id !== optionId)
          : [...prev, optionId]
      );
    };

    const Dropdown = ({ 
        label, 
        selected, 
        options, 
        handleToggle, 
        onClear 
      }) => (
        <div className="relative group">
          <button
            className="px-4 py-2 bg-transparent hover:bg-yellow-100 rounded-lg
                       flex items-center space-x-2 font-medium text-gray-700
                       transition-colors duration-200"
          >
            <span>{label}</span>
            {selected.length > 0 && (
              <span className="ml-2 inline-flex items-center justify-center px-2 py-0.5 
                              bg-yellow-100 text-yellow-700 text-xs font-medium rounded-full">
                {selected.length}
              </span>
            )}
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={`w-4 h-4 transition-transform duration-200 ${
                'group-hover:rotate-180'
            }`}>
                <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
            </svg>
          </button>
    
          <div className="absolute left-0 mt-2 w-48 bg-white/80 backdrop-blur-sm border border-gray-200 
                          rounded-lg shadow-lg py-2 z-50 invisible group-hover:visible
                          transition-all duration-200 opacity-0 group-hover:opacity-100">
            {options.map((option) => (
              <label
                key={option.id}
                className="flex items-center px-4 py-2 hover:bg-yellow-100 cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={selected.includes(option.id)}
                  onChange={() => handleToggle(option.id)}
                  className="h-4 w-4 rounded border-gray-300 text-yellow-500 
                             focus:ring-yellow-500 cursor-pointer"
                />
                <span className="ml-3 text-gray-700">{option.label || option?.username}</span>
              </label>
            ))}
            
            {selected.length > 0 && (
              <div className="border-t border-gray-200 mt-2 pt-2 px-4">
                <button
                  onClick={onClear}
                  className="text-sm text-yellow-600 hover:text-yellow-700"
                >
                  Clear all
                </button>
              </div>
            )}
          </div>
        </div>
    );

    useEffect(() => {
        const selectedFilters = {
            products: selectedProduct,
            allStatus: selectedAllStatus,
            farmer: selectedFarmer,
            remittanceStatus: selectedRemittanceStatus,
            referralStatus: selectedReferralStatus,
            insuranceStatus: selectedInsuranceStatus
        };
        onFilterChange(selectedFilters);
    }, [selectedProduct, selectedAllStatus, selectedFarmer, selectedRemittanceStatus, selectedReferralStatus, selectedInsuranceStatus]);
    return(
        <div>
            <h1 className="font-bold pb-4">Quick Filter</h1>
            <div className="flex flex-row items-center">
                <p className="font-bold text-gray-500">Filter by:</p>
                <div className='flex flex-row px-4 space-x-4 items-center justify-between'>
                    <Dropdown 
                    label="Product"
                    selected={selectedProduct}
                    options={productsOptions}
                    handleToggle={handleToggleProduct}
                    onClear={() => setSelectedProduct([])}
                    />
                    <Dropdown 
                        label="Opportunity Status"
                        selected={selectedAllStatus}
                        options={allStatus}
                        handleToggle={handleToggleAllStatus}
                        onClear={() => setSelectedAllStatus([])}
                    />
                    {fromAll && (
                      <Dropdown
                        label="Owner"
                        selected={selectedFarmer}
                        options={farmerListAPI}
                        handleToggle={handleFarmerListToggle}
                        onClear={() => setSelectedFarmer([])}
                    />
                    )}
                    {(selectedProduct.includes(1) || selectedProduct.includes(3)) ? (
                        <Dropdown
                            label="Re-KYC Status"
                            selected={selectedRemittanceStatus}
                            options={remittanceStatus}
                            handleToggle={handleToggleRemittanceStatus}
                            onClear={() => setSelectedRemittanceStatus([])}
                        />
                    ) : null}
                    {(selectedProduct.includes(4)) ? (
                        <Dropdown
                            label="Referral Status"
                            selected={selectedReferralStatus}
                            options={referralStatus}
                            handleToggle={handleToggleReferralStatus}
                            onClear={() => setSelectedReferralStatus([])}
                        />
                    ) : null}
                    {(selectedProduct.includes(2) || selectedProduct.includes(6)) ? (
                        <Dropdown
                            label="Insurance Status"
                            selected={selectedInsuranceStatus}
                            options={insuranceStatus}
                            handleToggle={handleToggleInsuranceStatus}
                            onClear={() => setSelectedInsuranceStatus([])}
                        />
                    ) : null}
                    <button 
                    onClick={() => {
                        setSelectedProduct([]);
                        setSelectedAllStatus([]);
                        setSelectedFarmer([]);
                        setSelectedRemittanceStatus([]);
                        setSelectedReferralStatus([]);
                        setSelectedInsuranceStatus([]);
                    }}
                    className="px-4 py-2 bg-transparent hover:bg-yellow-100 rounded-lg
                                flex items-center space-x-2 font-bold text-gray-700
                                underline transition-colors duration-200"
                    >Clear Filters
                    </button>
                </div>
            </div>
        </div>
    )
}

export default Filters;
